import { APP_CONFIG_DEVELOPER_CENTER } from '@hcs/app-configs';
import {
  useLogout,
  UserMenuAvatarButton,
  UserMenuLogoutButton,
} from '@hcs/authn';
import { useAppAccessCheck } from '@hcs/authz';
import {
  AppLauncher,
  UserMenu,
  UserMenuButtonProps,
  UserMenuButtons,
} from '@hcs/design-system';
import { GlobalHeader, GlobalHeaderExtendableProps } from '@hcs/hc-products';
import { SOLUTIONS_URL } from '@hcs/urls';

export interface PartnerToolsGlobalHeaderProps
  extends GlobalHeaderExtendableProps {
  buttonGroups?: UserMenuButtonProps[][];
}
export const OmDemoGlobalHeader = ({
  buttonGroups,
  ...props
}: PartnerToolsGlobalHeaderProps) => {
  const { data: hasDeveloperCenterAccess } = useAppAccessCheck(
    APP_CONFIG_DEVELOPER_CENTER.applicationKey,
  );
  const { mutate: logout } = useLogout();
  return (
    <GlobalHeader
      {...props}
      appLauncher={
        <AppLauncher
          dataHcName="om-demo-app-launcher"
          appConfigsExtended={[
            {
              hasAccess: hasDeveloperCenterAccess,
              appConfig: APP_CONFIG_DEVELOPER_CENTER,
            },
          ]}
          onClickApp={({ appConfig }) => {
            window.open(SOLUTIONS_URL + appConfig.rootPath, '_blank');
          }}
        />
      }
      authenticatedActionPopovers={
        <>
          {props.authenticatedActionPopovers}
          <UserMenu
            content={
              <>
                <UserMenuAvatarButton />
                <UserMenuButtons>
                  <UserMenuLogoutButton
                    dataHcName="om-demo-logout"
                    onLogout={logout}
                  />
                </UserMenuButtons>
              </>
            }
          />
        </>
      }
    />
  );
};
